const requestSheetAsJson = require('../requestSheetAsJson')

const { MEMBER_LIST_SHEET } = require('../../../../functions/globalConstants')

/**
 * 社員名簿スプレッドシートを読み込んで JSON 配列で返す
 * @see https://developers.google.com/gdata/samples/spreadsheet_sample
 * @see https://gist.github.com/terrywbrady/a03b25fe42959b304b1e
 */
const fetchMemberSheet = async () => requestSheetAsJson(MEMBER_LIST_SHEET)

module.exports = fetchMemberSheet
